import Chart from './Chart';
export default Chart;


// WEBPACK FOOTER //
// ./src/container/Chart/index.ts